var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarnTriangle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#FFF5F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8656_3109)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9193 33.1583C47.8944 31.5508 49.6289 30.5742 51.4991 30.5742C53.3693 30.5742 55.1038 31.5508 56.0789 33.1583L71.1997 58.4016C72.1503 60.048 72.156 62.0751 71.2146 63.7268C70.2731 65.3784 68.526 66.4065 66.6054 66.4275L36.3733 66.4274C34.4723 66.4065 32.7251 65.3784 31.7837 63.7268C30.8422 62.0751 30.8479 60.048 31.8131 58.377L46.9193 33.1583ZM34.8876 60.1853C34.5707 60.7341 34.5688 61.4098 34.8826 61.9604C35.1964 62.5109 35.7788 62.8536 36.3929 62.8605L66.5858 62.8606C67.2194 62.8536 67.8018 62.5109 68.1156 61.9604C68.4294 61.4098 68.4276 60.7341 68.1252 60.21L53.024 34.9997C52.7007 34.4667 52.1225 34.1412 51.4991 34.1412C50.8771 34.1412 50.3001 34.4653 49.9764 34.9962L34.8876 60.1853ZM49.7156 43.242C49.7156 42.257 50.5141 41.4585 51.4991 41.4585C52.4841 41.4585 53.2826 42.257 53.2826 43.242V50.376C53.2826 51.361 52.4841 52.1595 51.4991 52.1595C50.5141 52.1595 49.7156 51.361 49.7156 50.376V43.242ZM51.4991 59.2935C52.4841 59.2935 53.2826 58.495 53.2826 57.51C53.2826 56.525 52.4841 55.7265 51.4991 55.7265C50.5141 55.7265 49.7156 56.525 49.7156 57.51C49.7156 58.495 50.5141 59.2935 51.4991 59.2935Z",
    fill: "#D91F05"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8656_3109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 41,
    fill: "white",
    transform: "translate(23 29)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarnTriangle);
export default __webpack_public_path__ + "static/media/warnTriangle.409ee1e6c5588437b2cb8680fc97676b.svg";
export { ForwardRef as ReactComponent };